import { render } from "./ButtonRecipients.vue?vue&type=template&id=d367d60a"
import script from "./ButtonRecipients.vue?vue&type=script&lang=js"
export * from "./ButtonRecipients.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__